import Vue from 'vue'
import SvgIcon from 'vue-svgicon'
import '@/assets/vue-svgicon/assets'
import '@/assets/vue-svgicon/svgicon.css'

Vue.use(SvgIcon, { tagName: 'svgicon' })
